import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function PrivacidadPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="pt-20" data-id="element-763">
      <section className="relative py-16 md:py-20 bg-brand-navy overflow-hidden" data-id="element-764">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-brand-royal/30 via-brand-navy to-brand-navy" data-id="element-765"></div>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-766">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7
        }} data-id="element-767">
            <Link to="/" className="inline-flex items-center gap-2 text-white/60 hover:text-brand-gold transition-colors text-sm mb-8 group" data-id="element-768">
              <ArrowLeftIcon className="w-4 h-4 group-hover:-translate-x-1 transition-transform" data-id="element-769" />
              Volver al inicio
            </Link>
            <h1 className="text-4xl md:text-5xl font-heading font-bold text-white leading-tight" data-id="element-770">
              Política de Privacidad y{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-gold to-yellow-200" data-id="element-771">
                Protección de Datos
              </span>
            </h1>
          </motion.div>
        </div>
      </section>

      <section className="py-16 md:py-20" data-id="element-772">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-gray-700 leading-relaxed space-y-8" data-id="element-773">
          <div data-id="element-774">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-775">
              1. INTRODUCCIÓN
            </h2>
            <p data-id="element-776">
              En REDORG valoramos y respetamos la privacidad de nuestros
              usuarios. Esta Política de Privacidad describe cómo recopilamos,
              utilizamos, almacenamos y protegemos los datos personales que
              usted nos proporciona al utilizar nuestros sitios, APPs,
              terminales de autoatención u otros sistemas o canales de
              comunicación.
            </p>
          </div>

          <div data-id="element-777">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-778">
              2. RESPONSABLE DEL TRATAMIENTO
            </h2>
            <ul className="space-y-1 ml-1" data-id="element-779">
              <li data-id="element-780">
                <strong data-id="element-781">Nombre de la entidad:</strong> Fundación REDORG
              </li>
              <li data-id="element-782">
                <strong data-id="element-783">Dirección Legal:</strong> Edificio The Point, Oficina
                1803, Puerto Santa Ana, Guayaquil, Ecuador.
              </li>
              <li data-id="element-784">
                <strong data-id="element-785">Correo electrónico de contacto:</strong>{' '}
                protecciondatos@redorg.net
              </li>
            </ul>
          </div>

          <div data-id="element-786">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-787">
              3. DATOS PERSONALES QUE RECOPILAMOS
            </h2>
            <p className="mb-3" data-id="element-788">
              Podemos recopilar los siguientes datos personales cuando navegas o
              interactúas con nuestro sitio web u otros canales:
            </p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-789">
              <li data-id="element-790">Nombres y apellidos</li>
              <li data-id="element-791">Número de Cédula</li>
              <li data-id="element-792">Correo electrónico</li>
              <li data-id="element-793">Número de teléfono</li>
              <li data-id="element-794">
                Dirección IP y datos de navegación (cookies, ubicación, tipo de
                navegador)
              </li>
              <li data-id="element-795">
                Información proporcionada mediante formularios de contacto o
                suscripción
              </li>
            </ul>
          </div>

          <div data-id="element-796">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-797">
              4. FINALIDAD DEL TRATAMIENTO
            </h2>
            <p className="mb-3" data-id="element-798">
              Recopilamos tus datos con las siguientes finalidades:
            </p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-799">
              <li data-id="element-800">
                Enviar información institucional, boletines, eventos, productos
                y servicios
              </li>
              <li data-id="element-801">
                Atender consultas o solicitudes realizadas a través de
                formularios de contacto
              </li>
              <li data-id="element-802">Gestionar inscripciones a eventos o programas</li>
              <li data-id="element-803">
                Gestionar promociones, beneficios, sistemas de fidelización y
                otras actividades de marketing
              </li>
              <li data-id="element-804">
                Realizar análisis estadísticos de navegación (uso de cookies)
              </li>
              <li data-id="element-805">Cumplir con obligaciones legales y regulatorias</li>
            </ul>
          </div>

          <div data-id="element-806">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-807">
              5. LEGITIMACIÓN PARA EL TRATAMIENTO
            </h2>
            <p className="mb-3" data-id="element-808">
              El tratamiento de tus datos se realiza con base en:
            </p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-809">
              <li data-id="element-810">Tu consentimiento expreso</li>
              <li data-id="element-811">
                El interés legítimo de REDORG para cumplir su misión
                institucional
              </li>
              <li data-id="element-812">
                El cumplimiento de obligaciones legales, según la normativa
                ecuatoriana aplicable (Ley Orgánica de Protección de Datos
                Personales – LOPDP)
              </li>
            </ul>
          </div>

          <div data-id="element-813">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-814">
              6. DESTINATARIOS DE LOS DATOS
            </h2>
            <p className="mb-3" data-id="element-815">
              Tus datos personales no serán compartidos con terceros, salvo que:
            </p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-816">
              <li data-id="element-817">Tengamos tu consentimiento previo</li>
              <li data-id="element-818">Sea requerido por autoridad competente conforme a la ley</li>
              <li data-id="element-819">
                Se usen herramientas tecnológicas de terceros (por ejemplo, para
                envío de newsletters, CRM o formularios) con contratos que
                garantizan la protección de tus datos
              </li>
            </ul>
          </div>

          <div data-id="element-820">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-821">
              7. DERECHOS DEL TITULAR DE LOS DATOS
            </h2>
            <p className="mb-3" data-id="element-822">Tienes derecho a:</p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-823">
              <li data-id="element-824">Acceder a tus datos personales</li>
              <li data-id="element-825">Rectificar datos inexactos o incompletos</li>
              <li data-id="element-826">Eliminar tus datos (cuando proceda)</li>
              <li data-id="element-827">Oponerte al tratamiento</li>
              <li data-id="element-828">Solicitar la portabilidad de tus datos</li>
              <li data-id="element-829">Revocar el consentimiento en cualquier momento</li>
            </ul>
            <p className="mt-3" data-id="element-830">
              Puedes ejercer estos derechos escribiéndonos a{' '}
              <a href="mailto:protecciondatos@redorg.net" className="text-brand-royal underline hover:text-brand-navy transition-colors" data-id="element-831">
                protecciondatos@redorg.net
              </a>
            </p>
          </div>

          <div data-id="element-832">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-833">
              8. USO DE COOKIES
            </h2>
            <p data-id="element-834">
              Nuestros sitios utilizan cookies propias y de terceros para
              mejorar la experiencia de navegación y análisis del tráfico.
              Puedes aceptar, configurar o rechazar el uso de cookies desde el
              banner de consentimiento al ingresar al sitio.
            </p>
          </div>

          <div data-id="element-835">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-836">
              9. SEGURIDAD DE LA INFORMACIÓN
            </h2>
            <p data-id="element-837">
              REDORG aplica medidas de seguridad técnicas y organizativas
              adecuadas para proteger tus datos personales contra accesos no
              autorizados, pérdida, destrucción o alteración.
            </p>
          </div>

          <div data-id="element-838">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-839">
              10. CONSERVACIÓN DE LOS DATOS
            </h2>
            <p data-id="element-840">
              Tus datos serán conservados solo durante el tiempo necesario para
              cumplir con la finalidad para la que fueron recopilados o mientras
              exista una relación institucional o contractual. Posteriormente
              serán eliminados o anonimizados, según corresponda.
            </p>
          </div>

          <div data-id="element-841">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-842">
              11. CAMBIOS A ESTA POLÍTICA
            </h2>
            <p data-id="element-843">
              Nos reservamos el derecho de modificar esta Política de Privacidad
              en cualquier momento. Cualquier cambio será publicado con la fecha
              de actualización correspondiente.
            </p>
          </div>

          <div data-id="element-844">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-845">
              12. AUTORIDAD DE CONTROL
            </h2>
            <p data-id="element-846">
              Si consideras que tus derechos no han sido respetados, puedes
              presentar un reclamo ante la Autoridad de Protección de Datos
              Personales de Ecuador, la Superintendencia de Protección de Datos
              Personales.
            </p>
          </div>

          <div data-id="element-847">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-848">
              13. VIGENCIA
            </h2>
            <p data-id="element-849">
              La vigencia de estas Políticas de Privacidad y Protección de Datos
              es desde el 20 de marzo de 2026 y permanecerá vigente hasta que
              exista una nueva versión que la reemplace.
            </p>
          </div>
        </motion.div>
      </section>
    </div>;
}